import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import Link from 'common/components/LocalizedLink/LocalizedLink';
import { ANCHOR } from 'common/consts/common';
import LanguageService from 'services/Language.service';

//import style
import styles from './Company.module.scss';
import Buttonstyles from 'common/components/PrimaryButtonComponent/PrimaryButtonComponent.module.scss';

import { injectIntl } from 'react-intl';
import messages from './Company.intl';

//import components
import InfoBox from '../InfoBox/InfoBox';
import DividedBox from '../DividedBox/DividedBox';

@injectIntl
export default class CompanyComponent extends Component {
  static propTypes = {
    className: PropTypes.string,
    float: PropTypes.oneOf(['left', 'right']),
    company: PropTypes.object
  };

  static defaultProps = {
    className: '',
    float: 'left',
    company: {}
  };

  currentLanguage = LanguageService.getLang();

  // TODO remove exceptionalCase function when subsite will be done
  exceptionalCase(nameSlug) {
    const specialLink = [
      {
        name: 'holo4labs',
        pl: 'https://holo4labs.com',
        en: 'https://holo4labs.com'
      },
      {
        name: 'zonifero',
        pl: 'https://zonifero.com/pl',
        en: 'https://zonifero.com/en'
      },
      {
        name: 'growuperion',
        pl: 'https://growuperion.com/pl',
        en: 'https://growuperion.com/en'
      }
    ];
    const lang = LanguageService.getLang();
    const findItem = specialLink.find(el => el.name === nameSlug);
    return findItem ? findItem[lang] : null;
  }

  render() {
    const { className, float, company } = this.props;

    const isLeftFloat = float === 'left';

    const heroImageStyle = company.photo
      ? {
          backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
            company.photo
          )})`
        }
      : null;

    return (
      <div
        className={`${styles.Company}  ${
          isLeftFloat ? styles.CompanyFloatLeft : ''
        } ${className}`}
      >
        <div className={styles.CompanyMainContent}>
          <div className={styles.HeroImage} style={heroImageStyle} />
        </div>
        <div className={styles.CompanyAbout}>
          <DividedBox
            logo={company.logo}
            description={company.descriptionShort}
          />
        </div>
        <div className={styles.CompanyOverlayContent}>
          <InfoBox company={company} isLeftFloat={isLeftFloat} />

          {company.slug &&
            this.exceptionalCase(company.slug) && (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  this.exceptionalCase(company.slug) ||
                  `${ANCHOR.COMPANIES[this.currentLanguage]}/${company.slug}`
                }
                className={Buttonstyles.PrimaryButtonComponent}
              >
                <p className={styles.ButtonText}>
                  {this.props.intl.formatMessage(messages.button)}
                </p>
              </a>
            )}

          {company.slug &&
            !this.exceptionalCase(company.slug) && (
              <Link
                to={`${ANCHOR.COMPANIES[this.currentLanguage]}/${company.slug}`}
                className={Buttonstyles.PrimaryButtonComponent}
              >
                <p className={styles.ButtonText}>
                  {this.props.intl.formatMessage(messages.button)}
                </p>
              </Link>
            )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Companies/components/Company/Company.js